import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component: Main,
    children: [
        {
            path: "/sale",
            name: "sale",
            component: () => import('@/view/sale'),
            meta:{
                parent:true,
                parentName:"sale",
                name:"销售",
                assess:true
            },
            children: [
                {
                    path: "order",
                    name: "order",
                    component: () => import("@/view/sale/order"),
                    meta:{
                        parent:false,
                        parentName:"sale",
                        name:"销售单管理",
                        assess:true
                    }
                },
                {
                    path: "goodsInfo",
                    name: "goodsInfo",
                    component: () => import("@/view/sale/goods"),
                    meta:{
                        parent:false,
                        parentName:"sale",
                        name:"销售单明细",
                        assess:true
                    }
                },
                {
                    path: "returnOrder",
                    name: "returnOrder",
                    component: () => import("@/view/sale/returnOrder"),
                    meta:{
                        parent:false,
                        parentName:"sale",
                        name:"退货单管理",
                        assess:true
                    }
                },
                {
                    path: "changeOrder",
                    name: "changeOrder",
                    component: () => import("@/view/sale/changeOrder"),
                    meta:{
                        parent:false,
                        parentName:"sale",
                        name:"换货单管理",
                        assess:true
                    }
                },
            ]
        }
    ]

}



// WEBPACK FOOTER //
// ./src/router/modules/sale.js